import Modal from 'components/Modal/Modal'
import 'leaflet/dist/leaflet.css'
import 'pages/Map/index.scss'
import React from 'react'
import Map from './Map'

interface LocationModalProps {
  nextStep?: () => void
  onClose: () => void
  coords?: base.Coords
  updatePosition: (coords: base.Coords | undefined) => void
}

const LocationModal: React.FC<LocationModalProps> = ({ coords, updatePosition, onClose, nextStep }) => {
  return (
    <Modal
      onClose={onClose}
      title='Dodaj lokalizację'
      primaryButton='Zapisz lokalizację'
      primaryButtonAction={() => {
        if (nextStep) {
          nextStep()
        }
        onClose()
      }
      }
      secondaryButton='Anuluj'
      secondaryButtonAction={() => {
        updatePosition(undefined)
        onClose()
      }}>
      <Map
        coords={coords}
        updatePosition={updatePosition}
      />
    </Modal>
  )
}

export default LocationModal